import { Config } from "../../configurations/config";

export const CheckInCheckOutAPIs = {
  GetSupEmpList: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetSupervisorEmployeeWithJoiningDate`,
  GetSupEmpListForCM: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees?AllEmployees=false`,
  GetCheckInCheckOutStatus: `${Config.server_url}${Config.api_prefix}/MyOfficeHours/GetStatusTypes`,
  GetCheckInCheckOutRecord: `${Config.server_url}${Config.api_prefix}/MyOfficeHours/ExtractCheckinCheckout`,
  ExportToExcel: `${Config.server_url}${Config.api_prefix}/MyOfficeHours/ExtractCheckinCheckout`,
};
